/**
 * search_result_href.js
 * ---------------------
 * Tags a typeahead result link with the search it came from (sid, kind, surface, version) so
 * the click can be counted. Same-origin links only: partner URLs are returned untouched.
 * Shared by both nav wirings (shop_nav_wiring.js, shop_nav_v2_wiring.js).
 */
export function searchResultHref(url, searchId, searchVersion) {
  if (!url || !searchId) return url;
  try {
    const tagged = new URL(url, window.location.origin);
    if (tagged.origin !== window.location.origin) return url;
    tagged.searchParams.set("sid", searchId);
    tagged.searchParams.set("search_kind", "store");
    tagged.searchParams.set("search_surface", "autosuggest");
    if (searchVersion) tagged.searchParams.set("search_version", searchVersion);
    return `${tagged.pathname}${tagged.search}${tagged.hash}`;
  } catch (error) {
    console.error("search_result_href: could not tag a result link", error);
    return url;
  }
}
